export default {
  apiSuzuki: ENV.apiSuzuki,
};
